import { $host, $authHost, isDev } from './index'
import { httpPoint } from '../utils/const'

export const signin = async (login, password) => {
    const { data } = await $host.post(httpPoint.user + 'login', { login, password })
    return data
}

export const check = async () => {
    if (localStorage.getItem('token')) {
        const { data } = await $authHost.post('auth/check')
        localStorage.setItem('token', data.token)
        return data
    }
}

export const getInfo = async () => {
    if (localStorage.getItem('token')) {
        const { data } = await $authHost.post(httpPoint.user + 'getInfo')
        return data
    }
}

export const sendForm = async (name, data) => {
    const { data: response } = await $host.post(httpPoint.user + 'sendForm', { name, data })
    return response
}




